import React from 'react';
import PropTypes from 'prop-types';
import { domToReact } from 'html-react-parser';
import { InfoBox } from '@cdm/quickenloans-library/lib';
import IconResolver from '../../../../../components/Atoms/IconResolver';
import { wpClassNames } from './Constants';

const toInfoBox = ( parserData ) =>
{
    const { parserOptions: {replaceFn} } = parserData;
    const Wrapper = ({ name = '', type = '', attribs = {}, children = false }) =>
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'div') return null;
        const containerClassNames = attribs?.class?.split(' ') || [];
        if (!containerClassNames.includes(wpClassNames.INFOBOX_WRAPPER)) return null;
        
        const content = children ? domToReact(children[0].children, replaceFn()) : null;

        if (!content)
        {
            return null;
        }
        
        return (
            <InfoBox
                {...attribs['data-iconname'] ? { icon: <IconResolver iconName={attribs['data-iconname']} fontSize="large" /> } : {}}
                items={content}
            />
        );
    }

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['div']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            class: PropTypes.string,
            id: PropTypes.string
        }),
        children: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.string
        ])
    };

    return Wrapper;
};

export default toInfoBox;
